// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center {
  width: 25%;
  margin: 10px auto;
}

.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  margin-right: 10px;
}

/*.mat-icon {
  horizontal-align: right;

}*/
th {
  font-weight: bold;
  background-color: #E6E8EB;
}

table {
  width: 100%;
}

table thead th {
  color: white;
  font-size: 10pt;
  background-color: #3b5998;
}

.make-gold {
  background-color: #FAF6E2;
}

.make-red {
  background-color: #F0DDDD;
}

.make-green {
  background-color: #DEEED7;
}

li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}

.mat-fab {
  min-width: 100px;
  min-height: 75px;
}

.badge {
  float: right;
}

.content {
  padding: 5px;
}

.content > mat-card {
  width: 100px;
}

.nolist {
  list-style: none;
}

.example-margin {
  float: right;
  margin: 5px;
}

.example-headers-align {
  display: block;
  margin-top: 20px;
}

.badge {
  margin-left: auto;
}

.mat-expansion-panel {
  margin-bottom: 10px;
}

.mat-expansion-panel-header {
  margin-top: 10px;
}

.error-box {
  background-color: rgb(224, 52, 52);
  color: #fff;
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 10px;
}

.custom-table {
  width: 100%;
}

.heading {
  margin: auto;
}

th {
  font-weight: bold;
  background-color: #E6E8EB;
}

table {
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
}

table thead th {
  color: white;
  font-size: 8pt;
  background-color: #3b5998;
}

tr td {
  font-size: 8pt;
  padding: 5px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Show ellipsis for truncated text */
}

.edit-button {
  cursor: pointer;
}

.comment-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.disabled-row {
  pointer-events: none;
  background-color: rgba(177, 173, 173, 0.968627451);
  opacity: 0.6;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/pages/small-molecule/small-molecule.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AACA;;;EAAA;AAIA;EACE,iBAAA;EACA,yBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EAAiB,YAAA;EAAc,eAAA;EAAgB,yBAAA;AAO/C;;AANA;EACE,yBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AARA;EACE,yBAAA;AAWF;;AARA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAWF;;AARA;EACE,gBAAA;EACA,gBAAA;AAWF;;AARA;EACE,YAAA;AAWF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,gBAAA;AAUF;;AAPA;EACE,YAAA;EACA,WAAA;AAUF;;AANA;EACE,cAAA;EACA,gBAAA;AASF;;AANA;EACE,iBAAA;AASF;;AANA;EACE,mBAAA;AASF;;AANA;EACE,gBAAA;AASF;;AANA;EACE,kCAAA;EACA,WAAA;AASF;;AANA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AASF;;AALA;EACE,WAAA;AAQF;;AALA;EACE,YAAA;AAQF;;AALA;EACE,iBAAA;EACA,yBAAA;AAQF;;AALA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AAQF;;AALA;EACE,YAAA;EACA,cAAA;EACA,yBAAA;AAQF;;AALA;EACE,cAAA;EACA,YAAA;AAQF;;AAJA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,qCAAA;AAOF;;AAJA;EACE,eAAA;AAOF;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,oBAAA;EACA,kDAAA;EACA,YAAA;AAOF;AACA,ovJAAovJ","sourcesContent":[".center{\r\n  width: 25%;\r\n  margin: 10px auto;\r\n}\r\n\r\n.main-div{\r\n  height: 30vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\nbutton {\r\n  margin-right: 10px;\r\n}\r\n\r\n/*.mat-icon {\r\n  horizontal-align: right;\r\n\r\n}*/\r\nth {\r\n  font-weight: bold;\r\n  background-color: #E6E8EB;\r\n}\r\ntable {\r\n  width: 100%;\r\n}\r\ntable thead th { color: white; font-size:10pt; background-color: #3b5998}\r\n.make-gold {\r\n  background-color: #FAF6E2;\r\n}\r\n.make-red {\r\n  background-color: #F0DDDD;\r\n}\r\n.make-green {\r\n  background-color: #DEEED7;\r\n}\r\n\r\nli{\r\n  margin-top: 5px;\r\n  margin-left: 10px;\r\n  padding: 2px;\r\n}\r\n\r\n.mat-fab {\r\n  min-width: 100px;\r\n  min-height: 75px;\r\n}\r\n\r\n.badge {\r\n  float: right;\r\n}\r\n\r\n\r\n.content {\r\n  padding: 5px;\r\n}\r\n\r\n.content > mat-card {\r\n  width: 100px;\r\n}\r\n\r\n.nolist {\r\n  list-style: none;\r\n}\r\n\r\n.example-margin {\r\n  float: right;\r\n  margin: 5px;\r\n}\r\n\r\n\r\n.example-headers-align{\r\n  display: block;\r\n  margin-top: 20px;\r\n}\r\n\r\n.badge{\r\n  margin-left: auto;\r\n}\r\n\r\n.mat-expansion-panel{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mat-expansion-panel-header{\r\n  margin-top: 10px;\r\n}\r\n\r\n.error-box{\r\n  background-color:rgb(224, 52, 52);\r\n  color: #fff;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  max-width: 100%; \r\n  margin-bottom: 10px;\r\n \r\n}\r\n\r\n.custom-table {\r\n  width: 100%;\r\n}\r\n\r\n.heading{\r\n  margin: auto;\r\n \r\n}\r\nth {\r\n  font-weight: bold;\r\n  background-color: #E6E8EB;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n  margin-top: 10px;\r\n}\r\n\r\ntable thead th {\r\n  color: white;\r\n  font-size: 8pt;\r\n  background-color: #3b5998\r\n}\r\n\r\ntr td {\r\n  font-size: 8pt;\r\n  padding: 5px;\r\n}\r\n\r\n\r\nth, td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: left;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  overflow:hidden; /* Hide overflowing content */\r\n  text-overflow: ellipsis; /* Show ellipsis for truncated text */\r\n}\r\n\r\n.edit-button{\r\n  cursor: pointer;\r\n}\r\n\r\n.comment-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.disabled-row {\r\n  pointer-events: none;\r\n  background-color: #b1adadf7;\r\n  opacity: 0.6;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
